"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adjustmentStockpileTypes = void 0;
exports.adjustmentStockpileTypes = {
    SET_LOADING: 'ADJUSTMENT STOCKPILE TYPES SET LOADING',
    SET_ERROR: 'ADJUSTMENT STOCKPILE TYPES REDUCER SET ERROR',
    SET_DATA_GRID: 'ADJUSTMENT STOCKPILE TYPES GET DATA GRID',
    ON_PAGE_CHANGE: 'ADJUSTMENT STOCKPILE TYPES ON PAGE CHANGE',
    ON_SORT_CHANGE: 'ADJUSTMENT STOCKPILE TYPES ON SORT CHANGE',
    ON_MUTATION_CLICK: 'ADJUSTMENT STOCKPILE TYPES ON MUTATION',
    SET_DATA_SUMMARY: 'ADJUSTMENT STOCKPILE TYPES GET DATA SUMMARY',
    ON_FILTER_CHANGE: 'ADJUSTMENT STOCKPILE TYPES ON FILTER CHANGE',
    ON_SAVE_DATAITEM: 'ADJUSTMENT STOCKPILE TYPES ON SAVE DATAITEM',
    ON_CHANGE_DATAITEM: 'ADJUSTMENT STOCKPILE TYPES ON CHANGE DATAITEM',
    TOGGLE_SUCCESS_MODAL: 'ADJUSTMENT STOCKPILE TYPES SET SUCCESS MODAL',
    ON_DELETE_STOCKPILE: 'ADJUSTMENT STOCKPILE TYPES ON DELETE STOCKPILE',
    SET_DATA_GRID_HISTORY: 'ADJUSTMENT STOCKPILE HISTORY TYPES GET DATA GRID',
    SET_DATA_DROPDOWN_PIT: 'ADJUSTMENT STOCKPILE TYPES SET DATA DROPDOWN PIT',
    ON_PAGE_CHANGE_HISTORY: 'ADJUSTMENT STOCKPILE HISTORY TYPES ON PAGE CHANGE',
    ON_SORT_CHANGE_HISTORY: 'ADJUSTMENT STOCKPILE HISTORY TYPES ON SORT CHANGE',
    SET_DATA_DROPDOWN_AREA: 'ADJUSTMENT STOCKPILE TYPES SET DATA DROPDOWN AREA',
    SET_DATA_DROPDOWN_SEAM: 'ADJUSTMENT STOCKPILE TYPES SET DATA DROPDOWN SEAM',
    SET_EXPORT_DOCUMENTS_URL: 'HAULING STATISTIC TYPES SET EXPORT DOCUMENTS URL',
    SET_LAST_SUCCEED_UPLOAD: 'ADJUSTMENT STOCKPILE TYPES SET LAST SUCCEED UPLOAD',
    SET_DATA_DROPDOWN_BRAND: 'ADJUSTMENT STOCKPILE TYPES SET DATA DROPDOWN BRAND',
    ON_FILTER_CHANGE_HISTORY: 'ADJUSTMENT STOCKPILE HISTORY TYPES ON FILTER CHANGE',
    SET_LOADING_EXPORT_EXCEL: 'ADJUSTMENT STOCKPILE TYPES SET LOADING EXPORT EXCEL',
    CLEAR_EXPORT_DOCUMENTS_URL: 'HAULING STATISTIC TYPES CLEAR EXPORT DOCUMENTS URL',
    ON_MODIFY_TICKET_STOCKPILE: 'ADJUSTMENT STOCKPILE TYPES ON MODIFY TICKET STOCKPILE',
    SET_DATA_GRID_DELETED_LIST: 'ADJUSTMENT STOCKPILE TYPES GET DATA GRID DELETED LIST',
    ON_PAGE_CHANGE_DELETED_LIST: 'ADJUSTMENT STOCKPILE TYPES ON PAGE CHANGE DELETED LIST',
    ON_SORT_CHANGE_DELETED_LIST: 'ADJUSTMENT STOCKPILE TYPES ON SORT CHANGE DELETED LIST',
    SET_DATA_DROPDOWN_EXCAVATOR: 'ADJUSTMENT STOCKPILE TYPES SET DATA DROPDOWN EXCAVATOR',
    SET_DATA_DROPDOWN_CONTRACTOR: 'ADJUSTMENT STOCKPILE TYPES SET DATA DROPDOWN CONTRACTOR',
    ON_FILTER_CHANGE_DELETED_LIST: 'ADJUSTMENT STOCKPILE TYPES ON FILTER CHANGE DELETED LIST',
    GET_CHECKPOINT: 'ADJUSTMENT STOCKPILE TYPES ON GET CHECKPOINT',
    GET_DUMPTRUCK: 'ADJUSTMENT STOCKPILE TYPES ON GET DUMP TRUCK',
};
